import { Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
import { ChannelsSubList } from './ChannelsSubList';
import { CollapsableSection } from './CollapsableSection';
export const AlertShortMessage = ({ data }) => {
    const { t } = useAlertUiTranslation();
    if (data.textMessage) {
        return (React.createElement(CollapsableSection, { title: t('common.shortMessage'), header: React.createElement(ChannelsSubList, { data: data, filterChannels: ['sms', 'pager'] }) },
            React.createElement(Typography, { component: 'div', variant: 'body2', sx: {
                    p: 2,
                    whiteSpace: 'pre-wrap',
                } }, data.textMessage)));
    }
    else {
        return null;
    }
};
